// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { GetFiscalClosureParametersResponseFragmentFragment } from '../../fragments/generated/get-fiscal-closure-parameters-response.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetFiscalClosureParametersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFiscalClosureParametersQueryResult = { __typename?: 'Query', getFiscalClosureParameters: { __typename?: 'GetFiscalClosureParametersResponseDTO', dataGroupedByOwnerCorporateData: Array<{ __typename?: 'DataGroupedByOwnerCorporateDataDTO', cashRegisterFiscalClosureAllowed: boolean, ownerCorporateDataId: number, cashRegisters: Array<{ __typename?: 'CashRegisterDTO', id: number, invoiceBlocks: Array<string>, ownerCorporateDataId: number, description: string, address: string, port: string | null, localAddress: string | null, username: string | null, doubleCopy: boolean, cashRegisterType: { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null } }> }>, departments: Array<{ __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } }> } | null };

export const GetFiscalClosureParametersGql = gql`
    query GetFiscalClosureParameters {
  getFiscalClosureParameters {
    ...GetFiscalClosureParametersResponseFragment
  }
}
    ${GetFiscalClosureParametersResponseFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFiscalClosureParametersInjectable extends Apollo.Query<GetFiscalClosureParametersQueryResult, GetFiscalClosureParametersQueryVariables> {
    override document = GetFiscalClosureParametersGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */